import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getVariaveisAmbiente as getVariaveisAmbienteSdk,
  getVariavelAmbiente as getVariavelAmbienteSdk,
  putVariavelAmbiente as putVariavelAmbienteSdk,
} from '@sdk/Indicadores/VariaveisAmbiente';

//Action Types
export const Types = {
  GET_VARIAVEIS_AMBIENTE: 'GET_VARIAVEIS_AMBIENTE',
  GET_VARIAVEIS_AMBIENTE_SUCCESS: 'GET_VARIAVEIS_AMBIENTE_SUCCESS',
  GET_VARIAVEIS_AMBIENTE_ERROR: 'GET_VARIAVEIS_AMBIENTE_ERROR',

  GET_VARIAVEL_AMBIENTE: 'GET_VARIAVEL_AMBIENTE',
  GET_VARIAVEL_AMBIENTE_SUCCESS: 'GET_VARIAVEL_AMBIENTE_SUCCESS',
  GET_VARIAVEL_AMBIENTE_ERROR: 'GET_VARIAVEL_AMBIENTE_ERROR',

  PUT_VARIAVEL_AMBIENTE: 'PUT_VARIAVEL_AMBIENTE',
  PUT_VARIAVEL_AMBIENTE_SUCCESS: 'PUT_VARIAVEL_AMBIENTE_SUCCESS',
  PUT_VARIAVEL_AMBIENTE_ERROR: 'PUT_VARIAVEL_AMBIENTE_ERROR',

  SET_VARIAVEIS_AMBIENTE_VALORES_SELECIONADOS: 'SET_VARIAVEIS_AMBIENTE_VALORES_SELECIONADOS',

  RESET_VARIAVEIS_AMBIENTE: 'RESET_VARIAVEIS_AMBIENTE',
};

//Action Creators
export const getVariaveisAmbiente = (idCliente) => ({ type: Types.GET_VARIAVEIS_AMBIENTE, idCliente });
export const getVariaveisAmbienteSuccess = (data) => ({ type: Types.GET_VARIAVEIS_AMBIENTE_SUCCESS, data });
export const getVariaveisAmbienteError = (error) => ({ type: Types.GET_VARIAVEIS_AMBIENTE_ERROR, error });

export const getVariavelAmbiente = (idCliente, idInformacao) => ({ type: Types.GET_VARIAVEL_AMBIENTE, idCliente, idInformacao });
export const getVariavelAmbienteSuccess = (data) => ({ type: Types.GET_VARIAVEL_AMBIENTE_SUCCESS, data });
export const getVariavelAmbienteError = (error) => ({ type: Types.GET_VARIAVEL_AMBIENTE_ERROR, error });

export const putVariavelAmbiente = (data) => ({ type: Types.PUT_VARIAVEL_AMBIENTE, data });
export const putVariavelAmbienteSuccess = () => ({ type: Types.PUT_VARIAVEL_AMBIENTE_SUCCESS });
export const putVariavelAmbienteError = (error) => ({ type: Types.PUT_VARIAVEL_AMBIENTE_ERROR, error });

export const setValoresSelecionados = (valoresSelecionados) => ({
  type: Types.SET_VARIAVEIS_AMBIENTE_VALORES_SELECIONADOS,
  valoresSelecionados,
});

export const reset = () => ({ type: Types.RESET_VARIAVEIS_AMBIENTE });

//saga
function* fetchGetVariaveisAmbiente(action) {
  try {
    const { idCliente } = action;
    const variaveisAmbiente = yield call(getVariaveisAmbienteSdk, idCliente);
    yield put(getVariaveisAmbienteSuccess(variaveisAmbiente));
  } catch (err) {
    Notification.error(err.message);
    yield put(getVariaveisAmbienteError(err));
  }
}

function* fetchGetVariavelAmbiente(action) {
  try {
    const { idCliente, idInformacao } = action;

    const variavelAmbiente = yield call(getVariavelAmbienteSdk, idCliente, idInformacao);
    yield put(getVariavelAmbienteSuccess(variavelAmbiente));
  } catch (err) {
    Notification.error(err.message);
    yield put(getVariavelAmbienteError(err));
  }
}

function* fetchPutVariavelAmbiente(action) {
  try {
    const { data } = action;

    yield call(putVariavelAmbienteSdk, data);
    yield put(putVariavelAmbienteSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(putVariavelAmbienteError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_VARIAVEIS_AMBIENTE, fetchGetVariaveisAmbiente),
  takeLatest(Types.GET_VARIAVEL_AMBIENTE, fetchGetVariavelAmbiente),
  takeLatest(Types.PUT_VARIAVEL_AMBIENTE, fetchPutVariavelAmbiente),
];

// Reducer
const initialState = Map({
  variaveisAmbiente: List(),
  variavelAmbiente: {},
  valoresSelecionados: [],

  loadingVariaveisAmbiente: false,
  successVariaveisAmbiente: false,
  errorVariaveisAmbiente: false,

  loadingVariavelAmbiente: false,
  successVariavelAmbiente: false,
  errorVariavelAmbiente: false,

  puttingVariavelAmbiente: false,
  successPutVariavelAmbiente: false,
  errorPutVariavelAmbiente: false,
});

const handleGetVariaveisAmbiente = (state, action) => {
  return state.set('loadingVariaveisAmbiente', true).set('successVariaveisAmbiente', false).set('errorVariaveisAmbiente', false);
};

const handleGetVariaveisAmbienteSuccess = (state, action) => {
  const variaveisAmbiente = action.data;
  return state
    .set('variaveisAmbiente', List(variaveisAmbiente))
    .set('loadingVariaveisAmbiente', false)
    .set('successVariaveisAmbiente', true)
    .set('errorVariaveisAmbiente', false);
};

const handleGetVariaveisAmbienteError = (state, action) => {
  return state.set('loadingVariaveisAmbiente', false).set('successVariaveisAmbiente', false).set('errorVariaveisAmbiente', action.error);
};

const handleGetVariavelAmbiente = (state, action) => {
  return state.set('loadingVariavelAmbiente', true).set('successVariavelAmbiente', false).set('errorVariavelAmbiente', false);
};

const handleGetVariavelAmbienteSuccess = (state, action) => {
  return state
    .set('variavelAmbiente', action.data[0])
    .set('loadingVariavelAmbiente', false)
    .set('successVariavelAmbiente', true)
    .set('errorVariavelAmbiente', false);
};

const handleGetVariavelAmbienteError = (state, action) => {
  return state.set('loadingVariavelAmbiente', false).set('successVariavelAmbiente', false).set('errorVariavelAmbiente', action.error);
};

const handlePutVariavelAmbiente = (state, action) => {
  return state.set('puttingVariavelAmbiente', true).set('successPutVariavelAmbiente', false).set('errorPutVariavelAmbiente', false);
};

const handlePutVariavelAmbienteSuccess = (state, action) => {
  return state.set('puttingVariavelAmbiente', false).set('successPutVariavelAmbiente', true).set('errorPutVariavelAmbiente', false);
};

const handlePutVariavelAmbienteError = (state, action) => {
  return state.set('puttingVariavelAmbiente', false).set('successPutVariavelAmbiente', false).set('errorPutVariavelAmbiente', action.error);
};

const handleValoresSelecionados = (state, action) => {
  const { valoresSelecionados } = action;
  return state.set('valoresSelecionados', valoresSelecionados);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_VARIAVEIS_AMBIENTE:
      return handleGetVariaveisAmbiente(state, action);
    case Types.GET_VARIAVEIS_AMBIENTE_SUCCESS:
      return handleGetVariaveisAmbienteSuccess(state, action);
    case Types.GET_VARIAVEIS_AMBIENTE_ERROR:
      return handleGetVariaveisAmbienteError(state, action);

    case Types.GET_VARIAVEL_AMBIENTE:
      return handleGetVariavelAmbiente(state, action);
    case Types.GET_VARIAVEL_AMBIENTE_SUCCESS:
      return handleGetVariavelAmbienteSuccess(state, action);
    case Types.GET_VARIAVEL_AMBIENTE_ERROR:
      return handleGetVariavelAmbienteError(state, action);

    case Types.PUT_VARIAVEL_AMBIENTE:
      return handlePutVariavelAmbiente(state, action);
    case Types.PUT_VARIAVEL_AMBIENTE_SUCCESS:
      return handlePutVariavelAmbienteSuccess(state, action);
    case Types.PUT_VARIAVEL_AMBIENTE_ERROR:
      return handlePutVariavelAmbienteError(state, action);

    case Types.SET_VARIAVEIS_AMBIENTE_VALORES_SELECIONADOS:
      return handleValoresSelecionados(state, action);

    case Types.RESET_VARIAVEIS_AMBIENTE:
      return handleReset(state, action);

    default:
      return state;
  }
}
